import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import ConnectCreditCardLegacy from './ConnectCreditCardLegacy';
import ConnectCreditCardNew from './ConnectCreditCardNew';
/**
 * Renders a form for filling out credit-card details.
 * Delegates to Legacy or New UI based on CLIENT_ONBOARDING_NEW_FLOW.
 * Expects to be wrapped in an Elements provider from @stripe/react-stripe-js.
 */ export default function ConnectCreditCard(props) {
    const { CLIENT_ONBOARDING_NEW_FLOW } = useFeatureFlags();
    return CLIENT_ONBOARDING_NEW_FLOW ? /*#__PURE__*/ _jsx(ConnectCreditCardNew, _object_spread({}, props)) : /*#__PURE__*/ _jsx(ConnectCreditCardLegacy, _object_spread({}, props));
}
